import { render, staticRenderFns } from "./CampaignPromoters.vue?vue&type=template&id=52cf4000&scoped=true&"
import script from "./CampaignPromoters.vue?vue&type=script&lang=js&"
export * from "./CampaignPromoters.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPromoters.vue?vue&type=style&index=0&id=52cf4000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf4000",
  null
  
)

export default component.exports